import {
	IControlTokenResponse,
	IGetLoginParametersRequest,
	IGetLoginParametersResponse,
	IGetTOTPRegisterResponse,
	ILoginRequest,
	ILoginResponseWithMFA,
	ISelectMFATypeRequest,
	IValidateTOTPRegisterResponse,
	IValidationMFARequest
} from '../../../components/Login/entities';
import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'login', controller: 'Login') => ({
	ControlToken: new GetMethod<IControlTokenResponse, null>({
		service,
		controller,
		method: 'ControlToken'
	}),
	GetLoginParameters: new PostMethod<IGetLoginParametersResponse, IGetLoginParametersRequest>({
		service,
		controller,
		method: 'GetLoginParameters'
	}),
	Login: new PostMethod<ILoginResponseWithMFA, ILoginRequest>({
		service,
		controller,
		method: 'Login'
	}),
	Delegate: new PostMethod<any, any>({
		service,
		controller,
		method: 'Delegate'
	}),
	LoginAs: new PostMethod<any, any>({
		service,
		controller,
		method: 'LoginAs'
	}),
	LoginWithAccessToken: new PostMethod<any, any>({
		service,
		controller,
		method: 'LoginWithAccessToken'
	}),
	LoginWithDigitalSignature: new PostMethod<any, any>({
		service,
		controller,
		method: 'LoginWithDigitalSignature'
	}),
	LoginWithExternalUser: new PostMethod<any, any>({
		service,
		controller,
		method: 'LoginWithExternalUser'
	}),
	GetCaptcha: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetCaptcha'
	}),
	SelectMfaType: new PostMethod<boolean, ISelectMFATypeRequest>({
		service,
		controller,
		method: 'SelectMfaType'
	}),
	ValidationMfa: new PostMethod<ILoginResponseWithMFA, IValidationMFARequest>({
		service,
		controller,
		method: 'ValidationMfa'
	}),
	GetTotpRegister: new GetMethod<IGetTOTPRegisterResponse, null>({
		service,
		controller,
		method: 'GetTotpRegister'
	}),
	ValidationTotpRegister: new PostMethod<IValidateTOTPRegisterResponse, { pin: string }>({
		service,
		controller,
		method: 'ValidationTotpRegister'
	}),
	RecoveryTotpRegister: new PostMethod<boolean, { pin: string }>({
		service,
		controller,
		method: 'RecoveryTotpRegister'
	}),
	Logout: new GetMethod<any, any>({
		service,
		controller,
		method: 'Logout'
	}),
	Refresh: new GetMethod<any, any>({
		service,
		controller,
		method: 'Refresh'
	})
});

export { getMethods };
